// Farb weitergabe
document.addEventListener('DOMContentLoaded', () => {
  // Funktion zum Aktualisieren der Farbe für Dekofarbe 1
  function updateDekoColor1() {
    const dekoColor1Buttons = document.querySelectorAll('input[name="properties[Dekofarbe-1]"]');
    const dekoColor1Elements = document.querySelectorAll('.deko-color-1');

    dekoColor1Buttons.forEach(button => {
      if (button.checked) {
        const color = button.getAttribute('data-color');
        dekoColor1Elements.forEach(element => {
          element.style.fill = color;
        });
      }
    });
  }

  // Funktion zum Aktualisieren der Farbe für Dekofarbe 2
  function updateDekoColor2() {
    const dekoColor2Buttons = document.querySelectorAll('input[name="properties[Dekofarbe-2]"]');
    const dekoColor2Elements = document.querySelectorAll('.deko-color-2');

    dekoColor2Buttons.forEach(button => {
      if (button.checked) {
        const color = button.getAttribute('data-color');
        dekoColor2Elements.forEach(element => {
          element.style.fill = color;
        });
      }
    });
  }

  // Funktion zum Aktualisieren der Farbe für Schriftfarbe
  function updateSchriftColor() {
    const schriftColorButtons = document.querySelectorAll('input[name="properties[Schriftfarbe]"]');
    const textPreviewElements = document.querySelectorAll('.text-preview');
    const fontItems = document.querySelectorAll('.font_item');

    schriftColorButtons.forEach(button => {
      if (button.checked) {
        const color = button.getAttribute('data-color');
        textPreviewElements.forEach(element => {
          element.style.color = color;
        });
        fontItems.forEach(element => {
          element.style.color = color;
        });
      }
    });
  }

  // Event-Listener für Änderungen an den Dekofarben 1 Radio-Buttons hinzufügen
  const dekoColor1Buttons = document.querySelectorAll('input[name="properties[Dekofarbe-1]"]');
  dekoColor1Buttons.forEach(button => {
    button.addEventListener('change', updateDekoColor1);
  });

  // Event-Listener für Änderungen an den Dekofarben 2 Radio-Buttons hinzufügen
  const dekoColor2Buttons = document.querySelectorAll('input[name="properties[Dekofarbe-2]"]');
  dekoColor2Buttons.forEach(button => {
    button.addEventListener('change', updateDekoColor2);
  });

  // Event-Listener für Änderungen an den Schriftfarben Radio-Buttons hinzufügen
  const schriftColorButtons = document.querySelectorAll('input[name="properties[Schriftfarbe]"]');
  schriftColorButtons.forEach(button => {
    button.addEventListener('change', updateSchriftColor);
  });

  // Initiale Farbaktualisierung
  updateDekoColor1();
  updateDekoColor2();
  updateSchriftColor();
});